// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.em-coxcomb-legend-time-label {
    font-size: 13px;
}
.em-coxcomb-legend-time-segment {
    stroke: #444;
    stroke-width: 0.5;
    opacity: 0.4;
    fill: #ccc;
    cursor: pointer;
}
.em-coxcomb-legend-time-segment {
    stroke: #444;
    stroke-width: 0.5;
    opacity: 0.4;
    fill: #ccc;
    cursor: pointer;
}

.em-time-dimmed .em-coxcomb-chart path {
    visibility: hidden;
}
.em-time-dimmed .em-coxcomb-chart path.em-time-active {
    visibility: visible;
}
`, "",{"version":3,"sources":["webpack://./src/css/legend/coxcomb.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB","sourcesContent":[".em-coxcomb-legend-time-label {\r\n    font-size: 13px;\r\n}\r\n.em-coxcomb-legend-time-segment {\r\n    stroke: #444;\r\n    stroke-width: 0.5;\r\n    opacity: 0.4;\r\n    fill: #ccc;\r\n    cursor: pointer;\r\n}\r\n.em-coxcomb-legend-time-segment {\r\n    stroke: #444;\r\n    stroke-width: 0.5;\r\n    opacity: 0.4;\r\n    fill: #ccc;\r\n    cursor: pointer;\r\n}\r\n\r\n.em-time-dimmed .em-coxcomb-chart path {\r\n    visibility: hidden;\r\n}\r\n.em-time-dimmed .em-coxcomb-chart path.em-time-active {\r\n    visibility: visible;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
